import React from "react";
import "./stepsflow.css";

const steps = [
  {
    step: "Step 1",
    title: "Application Submit",
    desc:
      "In a free hour, when our power of choice is untrammelled and when nothing prevents.",
    img: "/images/steps/step-1.png",
  },
  {
    step: "Step 2",
    title: "Review & Verification",
    desc:
      "Back to the drawing-board show grit, for we should have a meeting to discuss the details.",
    img: "/images/steps/step-2.png",
  },
  {
    step: "Step 3",
    title: "Loan Approval",
    desc:
      "Hit the ground running do I have consent to record this meeting quick sync helicopter view.",
    img: "/images/steps/step-4.png",
  },
  {
    step: "Step 4",
    title: "Loan Disbursement",
    desc:
      "Radical candor upsell this is a no-brainer no need to talk to users, just base it on the.",
    img: "/images/steps/step-3.png",
  },
];

const StepsFlow = () => {
  return (
    <section className="steps-section">
      <div className="steps-wrapper">
        {steps.map((item, index) => (
          <div className="step-card" key={index}>
            <div className="step-arrow">
              <div className="step-img">
                <img src={item.img} alt={item.title} />
              </div>
              <span className="step-badge">{item.step}</span>
            </div>

            <h3>{item.title}</h3>
            <p>{item.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default StepsFlow;
